import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const westTampaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'West Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in West Tampa, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_west_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving West Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in West Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     historic neighborhoods and busy corridors of <strong>West Tampa</strong>. 
     Mature trees line the streets of this close knit community and while they 
     add character and shade, they also require expert attention to stay safe. 
     Overgrown canopies near power lines, aging oaks with weakened limbs, and 
     storm damage that leaves dangerous debris are all situations our team handles 
     with skill and efficiency.`,

    `We specialize in <strong>hazardous tree situations in dense urban and 
     residential settings</strong> tight lot removals, large limb reductions 
     over homes and sidewalks, storm response, and canopy thinning that reduces 
     wind resistance before hurricane season. We work carefully and clean up 
     completely on every job.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>West Tampa</strong> and surrounding 
     <strong>Hillsborough County</strong> neighborhoods keeping your property 
     safe and your trees healthy through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'West Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_WestTampa = () => <LocationPage config={westTampaConfig} />;
export default Services_WestTampa;
